<mat-form-field>

    <mat-label [ngClass]="{ 'required': configuration.isSelectionRequiredCallback && configuration.isSelectionRequiredCallback()}">{{ configuration.label }}</mat-label>

    <mat-select multiple [value]="values" [compareWith]="configuration.compareOptionsCallback">

        <mat-option #allOptions class="parent-option" *ngIf="configuration.allOptionsSelectionEnabledCallback()" (click)="handleAllParents(allOptions.selected)" [value]="configuration.allOptionsValueCallback()">
            <span class="ty-chevron-off"></span>
            <mat-checkbox [checked]="configuration.allOptionsSelectedCallback()">
                <span style="font-weight: bold">{{ configuration.allOptionsLabelCallback() | translate }}</span>
            </mat-checkbox>
        </mat-option>

        <mat-optgroup *ngFor="let parentOption of parentOptions; let parentIndex = index" class="optgroup-label-hide">

            <!-- Parent -->

            <mat-option #parentOptionReference class="parent-option" (click)="handleParent(parentOption, parentOptionReference.selected, parentIndex)" [value]="parentOption">
                <span class="ty-chevron" *ngIf="configuration.retrieveChildOptionsFromParentCallback(parentOption).length" [ngClass]="toggleParentOptionPanelClasses(parentIndex)" (click)="toggleParentOptionPanelStatus(parentIndex, $event)"></span>
                <span class="ty-chevron-off" *ngIf="!configuration.retrieveChildOptionsFromParentCallback(parentOption).length"></span>
                <mat-checkbox [checked]="configuration.selectedCallback(parentOption, parentIndex)">
                    {{ configuration.optionLabelCallback(parentOption, parentIndex) }}
                </mat-checkbox>
            </mat-option>

            <!-- Enfants -->

            <mat-option #childOptionReference class="child-option" *ngFor="let childOption of configuration.retrieveChildOptionsFromParentCallback(parentOption); let childIndex = index" [ngStyle]="childOptionStyles(parentIndex)" (click)="handleChild(childOption, parentOption, childOptionReference.selected)" [value]="childOption">
                <mat-checkbox [checked]="configuration.selectedCallback(childOption, childIndex)">
                    {{ configuration.optionLabelCallback(childOption, childIndex) }}
                </mat-checkbox>
            </mat-option>

        </mat-optgroup>

    </mat-select>

</mat-form-field>
